import { DatepickerRangeModel, DatepickerRangeOutput, ListRange, SearchCriteriaBase } from '../../../../common/models';
import { ListQueryParam } from '../../../../common/constants';
import { subDays } from 'date-fns';

export enum ExportDataRangeDate {
  DateTimeRange = 'dateTimeRange',
}

export type ExportDataTimestampValues = { [key in ExportDataRangeDate]: DatepickerRangeModel };

export type ExportDataDateValues = {
  [key in ExportDataRangeDate]: DatepickerRangeOutput;
};

export interface ExportDataSearchOutput {
  timezone: string;
  filter: ExportsListSearchCriteria;
}

export class ExportsListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;
  [ListQueryParam.Approved]: boolean;

  [ListQueryParam.DateTimeRange]: DatepickerRangeModel = new DatepickerRangeModel({
    start: subDays(new Date(), 90),
    end: null,
  });
  [ListQueryParam.ReportStatuses]: string[] = [];
  [ListQueryParam.ReportTypes]: string[] = [];

  constructor(params?: ExportsListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
